'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'expand',
    shape: _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('polygon', { points: '12,22.828 9.172,20 4.586,24.586 0,20 0,32 12,32 7.414,27.414' }),
        _react2.default.createElement('polygon', { points: '32,0 20,0 24.586,4.586 20.043,9.125 22.871,11.953 27.414,7.414 32,12' })
    ),
    viewbox: '0 0 32 32',
    label: 'Expand'
};
//# sourceMappingURL=expand.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-svg/lib/cjs/icons/expand.js
 ** module id = 687
 ** module chunks = 1
 **/